import { Module } from '@tokamakjs/react';

import { DashboardModule } from './pods/dashboard/dashboard.module';
import { ProfileModule } from './pods/profile/profile.module';

@Module({
  imports: [DashboardModule, ProfileModule],
})
export class AppModule {}
